function state() {
  return {
    document: null,
    campaigns: [],
    campaignsMeta: {},
    campaignContacts: [],
    campaignContactsMeta: {},
    templates: [],
    reports: [],
    reportsMeta: {},
  };
}

export default state;
